/* global document */

import inView from 'in-view';

const steps = document.querySelectorAll('.steps-list__item');
const items = steps.length;
const animationTime = 300;

function animateStepsIn() {
	let i;

	for (i = 0; i < items; i += 1) {
		setTimeout(setStepVisible, i * animationTime, i);
	}
}

function setStepVisible(i) {
	steps[i].classList.add('is--visible');
}

function init() {
	if (steps.length > 0) {
		inView.threshold(0.5);
		inView('.steps-list').once('enter', () => {
			animateStepsIn();
		});
	}
}

export default {
	init
};
